var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCarritoGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    width: 27,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#999999;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.6,6.5H5.9L5.7,3.9c0-0.4-0.4-0.7-0.8-0.7H3.2C2.8,3.1,2.4,3.5,2.4,4s0.4,0.8,0.8,0.8h0.9 c0.5,5.6-0.8-8.9,0.9,10.5c0.1,0.8,0.5,1.6,1.2,2.1c-1.3,1.6-0.1,4,2,4c1.7,0,2.9-1.7,2.3-3.3h4.5c-0.6,1.6,0.6,3.3,2.3,3.3 c1.4,0,2.5-1.1,2.5-2.5c0-1.4-1.1-2.5-2.5-2.5H8.2c-0.6,0-1.2-0.4-1.4-0.9L20,14.8c0.4,0,0.7-0.3,0.7-0.6l1.7-6.7 C22.5,7,22.1,6.5,21.6,6.5L21.6,6.5z M8.2,19.8c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8 C9.1,19.4,8.7,19.8,8.2,19.8z M17.4,19.8c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8 C18.3,19.4,17.9,19.8,17.4,19.8z M19.3,13.2L6.6,13.9L6.1,8.1h14.4L19.3,13.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarritoGrey);
export default __webpack_public_path__ + "static/media/icon_carrito_grey.ff275b780698524716654096ab9490fb.svg";
export { ForwardRef as ReactComponent };